export default __webpack_public_path__ + "static/media/963.73c1f155.png";